import { MOBILE_BREAKPOINT } from "@/lib/device-format";
import { useSyncExternalStore } from "react";

type DeviceFormat = {
  readonly isMobile: boolean;
  readonly isDesktop: boolean;
};

let mobileQuery: MediaQueryList | undefined;

/** One list for every caller, created on first use (not at import, for tests). */
const getMobileQuery = (): MediaQueryList => {
  mobileQuery ??= window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
  return mobileQuery;
};

const subscribe = (onChange: () => void): (() => void) => {
  const query = getMobileQuery();
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};

const getIsMobile = (): boolean => getMobileQuery().matches;

/**
 * Which tree the viewport calls for, known from the first render: a phone never
 * mounts the desktop branch for one frame — which remounted whatever it held,
 * scroll position and composer draft included — and both values follow a
 * resize across the breakpoint.
 */
export const useDeviceFormat = (): DeviceFormat => {
  const isMobile = useSyncExternalStore(subscribe, getIsMobile);
  return { isMobile, isDesktop: !isMobile };
};
